import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable } from 'rxjs';

import { FailedSlipViewModel } from './result-failed-slip.model';
import { FailedResultMessages, FailedResultService } from './result-failed.service';

@Component({
    selector: 'bs-digital-result-failed',
    templateUrl: './result-failed-container.component.html',
    styleUrls: ['./result-failed-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [FailedResultService],
    standalone: false,
})
export class ResultFailedSlipsContainerComponent implements OnInit {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    module = EpcotModule.Betslip;
    vm$: Observable<{ slips: FailedSlipViewModel[]; info: Nullable<FailedResultMessages> }>;
    constructor(private failedResultService: FailedResultService) {}

    ngOnInit(): void {
        this.vm$ = this.failedResultService.getFailedResultModel();
    }
}
